<template>
  <v-card>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Wholesale List</v-toolbar-title>
    </v-toolbar>

    <v-data-table :headers="headers" :items="wholesales" :search="search" :loading="loading" class="elevation-1">
      <template v-slot:item.active="{ item }">
        <v-chip :color="item.active ? 'green' : 'red'" dark small>
          {{ item.active ? 'Yes' : 'No' }}
        </v-chip>
      </template>

      <template v-slot:item.conditions="{ item }">
        <ul class="pa-0 ma-0">
          <li v-for="(c, i) in item.conditions" :key="i" style="font-size: 0.85rem">
            Min: {{ c.min_quantity }} | %: {{ c.discount_percentage || 0 }} | ₱{{ c.discount_fixed || 0 }}
          </li>
        </ul>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn text v-if="authPermissions.has('whole_sales:edit')" @click="$emit('edit', item)">
          <v-icon color="yellow darken-3">mdi-pencil</v-icon>
        </v-btn>
        <v-btn text @click="onSyncStocks(item.id)">
          <v-icon color="purple">mdi-table</v-icon>
        </v-btn>

        <v-btn text v-if="authPermissions.has('whole_sales:delete')" @click="$emit('delete', item)">
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import appAxios from '../../../../extra-functions/axios.extra'
import { ErrorPopup } from '../../../../lib/utils'

export default {
  name: 'IndexWholeSale',
  props: {
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      wholesales: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Active', value: 'active' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  created() {
    this.fetch()
  },
  watch: {
    search() {
      // this.fetch()
    },
  },
  methods: {
    /**
     * Description
     * @param {AbortController} controller=null
     */
    async fetch(controller = null) {
      this.loading = true
      try {
        const res = await appAxios(this.token).get('/whole-sales', {
          // params: { search: this.search },
          signal: controller?.signal,
        })
        this.wholesales = res.data
      } catch (e) {
        ErrorPopup.fire('Oops something went wrong')

        this.wholesales = []
      } finally {
        this.loading = false
      }
    },
    async onSyncStocks(wholeSaleId) {
      this.$emit('sync-stocks', wholeSaleId)
    },
  },
}
</script>
